module.exports = __webpack_public_path__ + "img/banner3.06bc3d9d.png";